import { RefObject } from 'react';
import { SelectionData } from '../utils/captureSelectionData';

interface ValidationResult {
  isValid: boolean;
  reason?: string;
}

export function validateApplyConditions(
  selection: SelectionData | null,
  containerRef: RefObject<HTMLDivElement>,
): ValidationResult {
  if (!selection) {
    return { isValid: false, reason: 'No selection available' };
  }

  if (!containerRef.current) {
    return { isValid: false, reason: 'Container ref not available' };
  }

  return { isValid: true };
}
